import { render, staticRenderFns } from "./goodslog.vue?vue&type=template&id=0ce7410b&"
import script from "./goodslog.vue?vue&type=script&lang=js&"
export * from "./goodslog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports